// Centralised list of React Query keys used by the admin app. Keep them
// here (vs scattered across services) so cross-service invalidations stay
// type-safe and easy to grep.
export const ADMIN_USER_KEY = ["admin-user"];
export const ADMIN_OVERVIEW_KEY = ["admin-overview"];
export const ADMIN_CAMPAIGNS_KEY = ["admin-campaigns"];
export const ADMIN_CAMPAIGN_KEY = (id: string) => ["admin-campaign", id];
export const ADMIN_USERS_KEY = (q: string) => ["admin-users", q];
export const ADMIN_USER_DETAIL_KEY = (id: string) => ["admin-user-detail", id];
export const ADMIN_REVENUE_KEY = ["admin-revenue"];
export const ADMIN_AUDIT_KEY = ["admin-audit"];
export const ADMIN_ANALYTICS_KEY = ["admin-analytics"];
